import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface JourneyTimelineProps {
  currentStage: number;
}
const stages = [{
  id: 1,
  name: 'Pre-Congress',
  icon: '🎯'
}, {
  id: 2,
  name: 'Vicinity',
  icon: '🧲'
}, {
  id: 3,
  name: 'Aisle',
  icon: '🚪'
}, {
  id: 4,
  name: 'Booth',
  icon: '💬'
}, {
  id: 5,
  name: 'Post',
  icon: '🔁'
}];
export function JourneyTimeline({
  currentStage
}: JourneyTimelineProps) {
  const progress = Math.max(0, Math.min(100, (currentStage - 1) / (stages.length - 1) * 100));
  return <div className="w-full max-w-4xl mx-auto mb-8 px-4" data-id="element-7">
      <div className="relative" data-id="element-8">
        <div className="absolute top-1/2 left-0 w-full h-1 bg-gray-200 -translate-y-1/2 rounded-full" data-id="element-9" />

        <motion.div className="absolute top-1/2 left-0 h-1 bg-[#E60012] -translate-y-1/2 rounded-full" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-10" />

        <div className="relative flex justify-between items-center" data-id="element-11">
          {stages.map(stage => {
          const isActive = stage.id === currentStage;
          const isCompleted = stage.id < currentStage;
          return <div key={stage.id} className="flex flex-col items-center gap-2" data-id="element-12">
                <motion.div className={`
                    w-10 h-10 rounded-full flex items-center justify-center border-2 z-10 bg-white
                    ${isActive || isCompleted ? 'border-[#E60012] text-[#E60012]' : 'border-gray-300 text-gray-400'}
                  `} initial={false} animate={{
              scale: isActive ? 1.2 : 1,
              borderColor: isActive || isCompleted ? '#E60012' : '#D1D5DB'
            }} transition={{
              duration: 0.3
            }} data-id="element-13">
                  {isCompleted ? <CheckCircle2 className="w-6 h-6" data-id="element-14" /> : <span className="text-lg" data-id="element-15">{stage.icon}</span>}
                </motion.div>
                <span className={`
                    text-xs font-medium absolute -bottom-6 w-24 text-center
                    ${isActive ? 'text-[#2D2926] font-bold' : 'text-gray-500'}
                  `} data-id="element-16">
                  {stage.name}
                </span>
              </div>;
        })}
        </div>
      </div>
    </div>;
}